<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">{{title}}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!allChoiced" @click="submit">{{$t('app.buttons.export')}}</v-btn>
        <v-btn @click="show=false">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <remote-autocomplete
                  :label="$t('app.labels.bu.name')"
                  :multiple="true"
                  key="2"
                  url="divisions/kv?type=BU"
                  v-model="query.buIds"
                />
              </v-layout>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :label="$t('app.labels.forecastDeliveryDate')"
                    :max="query.to"
                    :rules="[v => !!v || $t('app.labels.forecastDeliveryDate') + $t('app.validator.messages.required')]"
                    v-model="query.from"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.from"
                    :rules="[v => !!v || $t('app.labels.forecastDeliveryDate') + $t('app.validator.messages.required')]"
                    label="~"
                    v-model="query.to"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      show: false,
      query: {
        buIds: []
      },
      resolve: null,
      reject: null
    }
  },
  computed: {
    allChoiced() {
      return (
        this.query.buIds != null &&
        this.query.from != null &&
        this.query.to != null &&
        this.query.buIds.length > 0
      )
    }
  },
  methods: {
    popup(title) {
      this.title = title
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    submit() {
      this.show = false
      this.resolve(this.query)
    }
  }
}
</script>
